import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

export function render({ scroller }) {
  const footer = document.querySelector(".c-footer");

  const btn = footer.querySelector(".c-footer__top");
  btn.addEventListener("click", () => {
    scroller.scrollTo(".smooth-scroll");
  });

  const icons = footer.querySelector(".c-footer__icons");
  let translateIcons = gsap.timeline({
    scrollTrigger: {
      end: "bottom bottom",
      scroller: ".smooth-scroll",
      scrub: true,
      start: "-100% 75%",
      trigger: footer,
    },
  });
  translateIcons.to(icons, {
    ease: "Power1.easeInOut",
    translateX: 0,
  });
}
